/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */

import * as React from 'react';

enum KEY_CODES {
    ENTER = 13,
    ESCAPE = 27,
    SPACE = 32,
}

function onKeyPress(handler: () => void, useCodes: number[] = [KEY_CODES.ENTER, KEY_CODES.SPACE]) {
    return (evt: React.KeyboardEvent<HTMLElement>) => {
        if (useCodes.indexOf(evt.keyCode) >= 0) {
            handler();
            evt.preventDefault();
        }
    };
}

export { KEY_CODES, onKeyPress as default };
